// frontend/src/components/AtivarProgramaModal/AtivarProgramaModal.jsx
import React, { useState, useEffect } from 'react';
import { Modal, Form, Select, Button, message, Spin } from 'antd';
import { useMediaQuery } from 'react-responsive';
import { getProgramasFidelidade, ativarProgramaParaPortador } from '../../services/milhasService';
import { getErrorMessage } from '../../utils/errorHandler';
import { getMobileFullscreenModalProps } from '../../utils/mobileModal';
import SolicitarProgramaModal from '../SolicitarProgramaModal/SolicitarProgramaModal';

const { Option } = Select;

const AtivarProgramaModal = ({ visible, onClose, onSuccess, portadorId }) => {
    const isMobile = useMediaQuery({ maxWidth: 768 });
    const [form] = Form.useForm();
    const [programas, setProgramas] = useState([]);
    const [loading, setLoading] = useState(false);
    const [busca, setBusca] = useState('');
    const [solicitarVisible, setSolicitarVisible] = useState(false);

    // Hook de mensagem para consistência
    const [messageApi, contextHolder] = message.useMessage();

    useEffect(() => {
        if (visible) {
            form.resetFields();
            setBusca('');
            setLoading(true);
            getProgramasFidelidade()
                .then(response => {
                    setProgramas(response.data);
                })
                .catch((error) => {
                    // 2. USO NO FETCH
                    messageApi.error(getErrorMessage(error, 'Erro ao carregar a lista de programas de fidelidade.'));
                })
                .finally(() => {
                    setLoading(false);
                });
        }
    }, [visible, messageApi, form]);

    const handleOk = async () => {
        try {
            const values = await form.validateFields();
            setLoading(true);
            await ativarProgramaParaPortador({
                portador: portadorId,
                programa: values.programa_id
            });
            messageApi.success('Programa ativado com sucesso!');
            onSuccess();
        } catch (error) {
            // 3. USO NO SUBMIT
            messageApi.error(getErrorMessage(error, 'Erro ao ativar o programa.'));
        } finally {
            setLoading(false);
        }
    };

    return (
        <Modal
            title="Ativar Novo Programa de Fidelidade"
            open={visible}
            onCancel={onClose}
            onOk={handleOk}
            confirmLoading={loading}
            okText="Ativar"
            cancelText="Cancelar"
            okButtonProps={{ block: isMobile, size: isMobile ? 'large' : 'middle' }}
            cancelButtonProps={{ block: isMobile, size: isMobile ? 'large' : 'middle' }}
            {...getMobileFullscreenModalProps(isMobile)}
        >
            {contextHolder}
            <Spin spinning={loading}>
                <Form form={form} layout="vertical" size={isMobile ? 'large' : 'middle'}>
                    <Form.Item
                        name="programa_id"
                        label="Programa de Fidelidade"
                        rules={[{ required: true, message: 'Por favor, selecione um programa!' }]}
                    >
                        <Select
                            showSearch
                            placeholder="Selecione um programa"
                            optionFilterProp="children"
                            onSearch={setBusca}
                            notFoundContent={
                                <Button type="link" onClick={() => setSolicitarVisible(true)}>
                                    {busca ? `Solicitar "${busca}"` : 'Solicitar novo programa'}
                                </Button>
                            }
                        >
                            {programas.map(p => (
                                <Option key={p.id} value={p.id}>{p.nome}</Option>
                            ))}
                        </Select>
                    </Form.Item>
                </Form>
                <Button type="link" style={{ padding: 0 }} onClick={() => setSolicitarVisible(true)}>
                    Não encontrou o programa? Solicitar cadastro
                </Button>
            </Spin>
            <SolicitarProgramaModal
                visible={solicitarVisible}
                onClose={() => setSolicitarVisible(false)}
                nomeInicial={busca.trim()}
            />
        </Modal>
    );
};

export default AtivarProgramaModal;